import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CookieBarService } from 'ras-cookie-bar';
import { RasGtmService } from 'ras-gtm';
import { ScriptLoaderService, StylesheetLoaderService } from 'ras-util';
import { AppConfigurationService } from './app-configuration.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CuestionariosSaludModule } from './cuestionarios-salud/cuestionarios-salud.module';
import { literalConstant } from './shared/constant/literal.constant';
import { RedirectBeforeGuard } from './shared/redirect-guard/redirect-before';
import { AppStateService } from './shared/service/ui/app-state.service';

export function getBaseUrl() {
  return window.location.pathname.includes('seguros-de-salud/calcular') ? window.location.origin + '/seguros-de-salud/calcular/' : window.location.origin + '/';
}

export function initializeSessionConfig(configService: AppConfigurationService) {
  configService.loadURLConfigurationData();
  return () => configService.loadConfigurationData();
}

export function initializeAbTestConfig(configService: AppConfigurationService) {
  return () => configService.loadABTestConfigurationData();
}

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, HttpClientModule, CuestionariosSaludModule],
  providers: [
    { provide: literalConstant.API_URL, useFactory: getBaseUrl },
    AppConfigurationService,
    RedirectBeforeGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSessionConfig,
      deps: [AppConfigurationService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAbTestConfig,
      deps: [AppConfigurationService],
      multi: true
    },
    DatePipe,
    // ui-state
    AppStateService,
    // util
    ScriptLoaderService,
    StylesheetLoaderService,

    // ng-module
    RasGtmService,
    CookieBarService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
